import api from './api';

// Envía un mensaje de soporte/contacto al administrador (endpoint público).
export const sendSupportMessage = (data) =>
  api.post('/support/contact', data).then((r) => r.data);
